module.exports = __webpack_public_path__ + "media/images/ui__arrowLeftInactive-35d9eb278de076064907d3a24afc1c5e.png";